export default __webpack_public_path__ + "static/media/paid-creditcard.6a90e221.svg";